import { Entity } from './Entity';

export class GameLoop {
  entities: Entity[] = [];

  add(entity: Entity) {
    entity.connect(this);
    this.entities.push(entity);
  }

  destroyAll() {
    this.entities.forEach(entity => entity.destroy());
  }

  step(delta: number) {
    this.entities.forEach(entity => entity.step(delta));
  }
}
